import { render, staticRenderFns } from "./DangKyChuongTrinhForm.vue?vue&type=template&id=1435ce5a&"
import script from "./DangKyChuongTrinhForm.vue?vue&type=script&lang=js&"
export * from "./DangKyChuongTrinhForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports